import {FormioBase} from "./formiobase";

export class Button extends FormioBase {

  public inputType = "submit";
  public title = "Submit";
  public icon = "";
  public isAvailable = false;
  public schema: any = {
    title: "button",
    components: [{
      type: "button",
      theme: "primary",
      disableOnInvalid: true,
      action: "submit",
      block: false,
      rightIcon: "",
      leftIcon: "",
      size: "md",
      key: undefined,
      tableView: false,
      label: "Submit",
      input: true,
      disabled: true,
      validate: {
        required: false,
      },
      customClass: "ds-buttton",
    }],
  };
}
